import React, {useEffect, useState, useCallback, useMemo, useRef} from "react";
import PageSerch from "./Components/PageSerch";
import DynamicBreadcrumbs from "../../../Uitiles/DynamicBreadcrumbs";
import DoctorListCard from "./Components/DoctorListCard";
import GoogleAd from "./Components/GoogleAd";
import { oneKlicks } from "../../../SDK/oneclick";
import Advertisement from "./Components/Advertisement";
import Paginationnew from "../../../Uitiles/Paginationnew";
import { useLocation } from 'react-router-dom';
import "./SerchDocters.css";
import HospitalListCard from "./Components/HosptalListCard";
import PageSidebar from "../../../Uitiles/PageSidebar";
import { DoctorCardsSkeleton } from "./Components/DoctorCardSkeleton";



const SerchHospital = () => {
    const locationObj = useLocation(); // React Router location
    const [location, setLocation] = useState({ lat: "", lng: "" });
    const [searchLocation, setSearchLocation] = useState(false);
    const [address, setAddress] = useState("");  
    const [isLoading, setIsLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedSpeciality, setSelectedSpeciality] = useState("");
    const [selectedService, setSelectedService] = useState("");
    const [listing_type, setListingType] = useState("doctor");
    const [speciality, setSpeciality] = useState("");
    const [hospital, setHospital] = useState("");
    const [city, setCity] = useState("");
    const [state, setState] = useState("");
    const [country, setCountry] = useState("");
    const [zip, setZip] = useState("");
    const [page, setPage] = useState(1);
    const [totalPages, setTotalPages] = useState(0);
    const [page_size, setPageSize] = useState(20);
    const [radius, setRadius] = useState(0);
    const [user_id, setUserId] = useState(0);
    const [keyword, setKeyword] = useState("");
    const [doctors, setDoctors] = useState([]);
    const [error, setError] = useState(null);
    const isFetching = useRef(false);
    const fetchTimeout = useRef(null);
    const [sortBy, setSortBy] = useState("");
    const [sortOrder, setSortOrder] = useState("");
    const [advertisement, setAdvertisement] = useState([]);
    const [serchtime, setSerchtime] = useState(0);

    const queryParams = new URLSearchParams(locationObj.search);
    const searchFromUrl = queryParams.get('search');
    const latFromUrlat = queryParams.get('lat');
    const lngFromUrlng = queryParams.get('lng');
    const pageFromUrl = parseInt(queryParams.get('page'), 10);
    const otherlocationFromUrl = queryParams.get('otherlocation');


    // Debounce function
    const debounce = (func, wait) => {
        let timeout;
        return function executedFunction(...args) {
            const later = () => {
                clearTimeout(timeout);
                func(...args);
            };
            clearTimeout(timeout);
            timeout = setTimeout(later, wait);
        };
    };

    const handleLocationChange = (newLocation) => {
        console.log("handleLocationChange serchdocters newLocation :", newLocation);
        if (setLocation) {
            setSearchLocation(true);
            console.log("handleLocationChange serchdocters setLocation :", newLocation);
            setLocation(newLocation);
        }
    };

    // ✅ Extract `page` from URL on mount or when URL changes  
    useEffect(() => {
        const queryParams = new URLSearchParams(locationObj.search);
        const pageFromUrl = parseInt(queryParams.get('page'), 10);
        const searchFromUrl = queryParams.get('search');
        const latFromUrl = queryParams.get('lat');
        const lngFromUrl = queryParams.get('lng');
        const otherlocationFromUrl = queryParams.get('otherlocation');
        if (!isNaN(pageFromUrl)) {
            setPage(pageFromUrl);
        }
        if (searchFromUrl) {
            console.log("searchFromUrl", searchFromUrl);
            setSearchTerm(searchFromUrl);
        }
        if (latFromUrl) {
            setLocation({ lat: latFromUrl, lng: lngFromUrl });
        }
        getadvertisement();
    }, [locationObj.search]);

    const getadvertisement = async () => {
        try {
            const tableSchema = '';
            const tableName = 'banners';
            const conditions = {
                banner_type: 'hospital_listing'
            };
            let orderBy = 'RAND()';
            const search = {};
            const pagination = { };
            const margedata = [];
            const range = [];
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
            console.log("getadvertisement response :", response);
            setAdvertisement(response.data);
        } catch (err) {
            console.error('Error fetching advertisement:', err);
            setAdvertisement([]);
        }
    }

    const fetchData = useCallback(async () => {
        // Prevent multiple simultaneous calls
        if (isFetching.current) {
            return;
        }

        try {
            isFetching.current = true;
            setIsLoading(true);
            setError(null);

            console.log("fetchData doctor starting time", new Date().toISOString());
            const starttime = new Date().getTime();

            const allDoctorIds = new Set();
            let uniqueDoctorIds = [];

            if(searchTerm && searchTerm !== ""){
                console.log("fetchData doctor searchTerm :", searchTerm);
                const searchTermLowerCase = searchTerm.toLowerCase();
                const tableSchema = '';
                const tableName = 'specialities';
                const conditions = {};
                const orderBy = 'RAND()';
                const search = {
                    name: searchTermLowerCase
                };
                const pagination = {};
                console.log("fetchData doctor specialities search :", search);
                const margedata = [
                    {
                        target_table: 'doctor_specialities',
                        target_column: 'speciality_id',
                        target_value: 'id',
                        target_label: 'doctor_specialities'
                    }
                ];
                const range = [];
                console.log("fetchData doctor specialities conditions :", conditions);
                const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
                console.log("fetchData doctor specialities response :", response);
                
                // Extract and deduplicate doctor IDs from the response
                if (response && response.data && Array.isArray(response.data)) {
                    
                    
                    response.data.forEach(speciality => {
                        console.log("fetchData doctor specialities speciality :", speciality);
                        console.log("fetchData doctor specialities speciality.doctor_specialities :", speciality.doctor_specialities);
                        if (speciality.doctor_specialities && Array.isArray(speciality.doctor_specialities)) {
                            console.log("fetchData doctor specialities speciality.doctor_specialities :", speciality.doctor_specialities);
                            speciality.doctor_specialities.forEach(doctorSpeciality => {
                                console.log("fetchData doctor specialities doctorSpeciality :", doctorSpeciality);
                                if (doctorSpeciality.doctor_id) {
                                    console.log("fetchData doctor specialities doctorSpeciality.doctor_id :", doctorSpeciality.doctor_id);
                                    allDoctorIds.add(doctorSpeciality.doctor_id);
                                }
                            });
                        }
                    });

                    console.log("fetchData doctor specialities allDoctorIds :", allDoctorIds);
                    
                    // Convert Set to Array for easier use
                    uniqueDoctorIds = Array.from(allDoctorIds);

                    console.log("fetchData doctor specialities uniqueDoctorIds :", uniqueDoctorIds);
                    
                    console.log("fetchData doctor === DOCTOR IDS EXTRACTION RESULTS ===");
                    console.log("fetchData doctor All unique doctor IDs:", uniqueDoctorIds);
                    console.log("fetchData doctor Total unique doctors found:", uniqueDoctorIds.length);
                    console.log("fetchData doctor Individual doctor IDs:");
                    uniqueDoctorIds.forEach((doctorId, index) => {
                        console.log(`fetchData doctor  ${index + 1}. Doctor ID: ${doctorId}`);
                    });
                    console.log("fetchData doctor === END DOCTOR IDS EXTRACTION ===");
                }
                setSpeciality(response.data);
            }
            
            
            
            const tableSchema = '';
            const tableName = 'users';
            const conditions = {
                user_type: 'hospitals'
                // id: 4875
            };
            let orderBy = '';
            if (sortBy && sortOrder) {
                orderBy = `${sortBy} ${sortOrder}`;
            } else {
                orderBy = 'RAND()';
            }

            const search = {
                display_name: searchTerm,
                ...uniqueDoctorIds.length > 0 && {
                    id: uniqueDoctorIds
                }
            };
            const pagination = {
                page: pageFromUrl ? pageFromUrl : page,
                limit: page_size
            };
            const margedata = [
                {
                    target_table: "hospital_specialities",
                    target_column: "hospital_id",
                    target_value: "id",
                    target_label: "doctor_specialities",
                    "margedata" :[
                        {
                            target_table: "specialities",
                            target_column: "id",
                            target_value: "speciality_id",
                            target_label: "specialities"
                        },
                        {
                            target_table: "services",
                            target_column: "id",
                            target_value: "service_id",
                            target_label: "services"
                        }
                    ],
                    "search_fields": [
                        {
                            speciality_id: selectedSpeciality,
                            service_id: selectedService
                        }
                    ]
                },
                {
                    target_table: "doctor_experience_education",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "doctor_experience_education"
                },
                {
                    target_table: "appointment_settings",
                    target_column: "doctor_id",
                    target_value: "id",
                    target_label: "appointment_settings"
                },
                {
                    target_table: "hospitals_default_location",
                    target_column: "user_id",
                    target_value: "id",
                    target_label: "doctor_default_location"
                },
                {
                    target_table: "hospital_doctors",
                    target_column: "hospital_id",
                    target_value: "id",
                    target_label: "number_of_doctors"
                }
            ];
            const range = {
                latitude: searchLocation ? location.lat : latFromUrlat ? latFromUrlat : location.lat,
                longitude: searchLocation ? location.lng : lngFromUrlng ? lngFromUrlng : location.lng,
                radius: 50, // in kilometers
                target_latitude: "lat",
                target_longitude: "lng",
                table_name: "hospitals_default_location",       // join table
                join_column: "user_id",            // foreign key in user_location
                base_column: "id"                  // primary key in user
            };
            
            const response = await oneKlicks.read(tableSchema, tableName, conditions, orderBy, search, pagination, margedata, range);
            console.log("fetchData doctor ending time", new Date().toISOString());
            
            if (!response || !response.data) {
                throw new Error('Invalid response format from server');
            }
            console.log("fetchData response :", response);
            setTotalPages(response.totalPages);
            setDoctors(response.data);
            const endtime = new Date().getTime();
            const searchDuration = (endtime - starttime) / 1000; // Convert to seconds
            setSerchtime(searchDuration);
        } catch (err) {
            console.error('Error fetching doctors:', err);
            setError(err.message || 'Failed to fetch doctors data');
            setDoctors([]);
        } finally {
            setIsLoading(false);
            isFetching.current = false;
        }
    }, [location, searchTerm, page, page_size]);

    // Memoize the doctors list to prevent unnecessary re-renders
    const memoizedDoctors = useMemo(() => doctors, [doctors]);

    // Initial load
    useEffect(() => {
        fetchData();
    }, []);

    useEffect(() => {
        if (fetchTimeout.current) {
            clearTimeout(fetchTimeout.current);
        }
    
        fetchTimeout.current = setTimeout(() => {
            // Get existing query params from URL
            const params = new URLSearchParams(window.location.search);
    
            // Update only the params that changed
            if (searchTerm !== undefined) params.set('search', searchTerm);
            if (location?.lat !== undefined) params.set('lat', location.lat);
            if (location?.lng !== undefined) params.set('lng', location.lng);
            if (selectedSpeciality !== undefined) params.set('speciality', selectedSpeciality);
            if (selectedService !== undefined) params.set('service', selectedService);
            if (page !== undefined) params.set('page', page);
    
            // Update the URL without redirecting
            const newUrl = `${window.location.pathname}?${params.toString()}`;
            window.history.replaceState(null, '', newUrl);
    
            // Fetch data
            fetchData();
        }, 500);
    
        return () => {
            if (fetchTimeout.current) clearTimeout(fetchTimeout.current);
        };
    }, [searchTerm, location, page, selectedSpeciality, selectedService]);

    const handleSortChange = (e) => {
        console.log("handleSortChange", e.target.value);
        setSortBy(e.target.value);
    };

    const handlesortorder = (e) => {
        console.log("handlesortorder", e.target.value);
        setSortOrder(e.target.value);
    };

    const handlePageChange = (pageNumber) => setPage(pageNumber);

    return (
        <div>
            <PageSerch location={location} setLocation={setLocation} searchTerm={searchTerm} setSearchTerm={setSearchTerm} selectedSpeciality={selectedSpeciality} setSelectedSpeciality={setSelectedSpeciality} selectedService={selectedService} setSelectedService={setSelectedService} otherlocation={otherlocationFromUrl}/>
            <DynamicBreadcrumbs />
            <main id="dc-main" className="dc-main dc-haslayout">
                <div className="dc-haslayout dc-parent-section">
                    <div className="container">
                        <div className="row">
                            <div id="dc-twocolumns" className="dc-twocolumns dc-haslayout d-flex dc-enabled">
                                <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-9 order-first">
                                    {isLoading ? (
                                        <DoctorCardsSkeleton count={6} />
                                    ) : (
                                        <>
                                            <div className="dc-searchresult-holder">
                                                <div className="dc-searchresult-head">
                                                    <div className="dc-title">
                                                        <h4>
                                                            {error ? (
                                                                <span className="text-danger">{error}</span>
                                                            ) : (
                                                                <strong>{memoizedDoctors.length}</strong>
                                                            )}&nbsp;matches found

                                                            <span className="text-danger"> &nbsp; Search time: {serchtime ? `${serchtime.toFixed(2)}s` : '0.00s'}</span>
                                                        </h4>
                                                    </div>
                                                    <div className="dc-rightarea">
                                                        <div className="dc-select">
                                                            <select name="orderby" className="orderby" onChange={handleSortChange} value={sortBy}>
                                                                <option value="">Sort By</option>
                                                                <option value="id">Latest</option>
                                                                <option value="display_name">Name</option>
                                                                <option value="created_at">Registration date</option>
                                                            </select>
                                                        </div>
                                                        <div className="dc-select">
                                                            <select name="order" className="order" onChange={handlesortorder} value={sortOrder}>
                                                                <option value="ASC">Ascending</option>
                                                                <option value="DESC">Descending</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {memoizedDoctors.map((doctor, index) => (
                                                <React.Fragment key={doctor.id}>
                                                    <DoctorListCard doctor={doctor} type="hospital" />
                                                    {(index + 1) % 5 === 0 && index !== memoizedDoctors.length - 1 && (
                                                        <Advertisement advertisement={advertisement[(Math.floor(index / 5)) % advertisement.length]} />
                                                    )}
                                                </React.Fragment>
                                            ))}

                                            <div id="doctor-results-pages">
                                                <div className="dc-paginationvtwo">
                                                    <Paginationnew currentPage={page} totalPages={totalPages} handlePageChange={handlePageChange} />
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>


                                
                                <div className="col-12 col-md-5 col-lg-4 col-xl-3 order-last">
                                    <PageSidebar />
                                </div>
                            </div>

                            
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
};

export default React.memo(SerchHospital);
